<template>
  <section>
    <NavBar
      @toggleSideBar="toggleSiteMap"
      :sideBarOpen="siteMapOpen"
      :links="content.navigation.links"
      :backgroundColor="backgroundColour"
      :textColor="textColour"
      :is-home-page="false"
      :logo="
        $isMobile()
          ? require('../assets/images/house-orange.png')
          : require(`../assets/images/${logoType}.png`)
      "
      data-aos="fade-down"
    />
    <SiteMap
      @closeSiteMap="toggleSiteMap"
      v-if="siteMapOpen"
      :selections="content.navigation.selections"
      data-aos="fade-down"
    />
    <div class="more-hero">
      <video class="more-hero__video" autoplay loop muted>
        <source src="../assets/images/hero-video-more-2024.mp4" type="video/mp4" />
      </video>
    </div>
    <h1 class="more-hero__title" data-aos="fade-up">
      {{ content.hero.title }}
    </h1>
    <div class="intro">
      <div class="intro__left">
        <h3 class="intro__left--title" data-aos="fade-right">
          {{ content.intro.title }}
        </h3>
        <p class="intro__left--body" data-aos="fade-up">
          {{ content.intro.body_1 }}
        </p>
        <p class="intro__left--body" data-aos="fade-up">
          {{ content.intro.body_2 }}
        </p>
        <a
          :href="`mailto:${content.intro.email}`"
          target="_blank"
          class="button light"
          >{{ content.intro.button_1 }}</a
        >
      </div>
      <div class="intro__right">
        <img
          class="intro__right--image"
          src="../assets/images/rainbow-sushi.png"
          data-aos="fade-left"
        />
      </div>
    </div>
    <img class="logo-razor" src="../assets/images/orange-razor.png" />
    <div class="logos" id="logos">
      <div class="logos__wrapper">
        <div class="logos__wrapper--left">
          <div class="inner-left">
            <img
              class="woman"
              src="../assets/images/woman-helmet.png"
              data-aos="fade-right"
            />
            <img
              class="bikes"
              src="../assets/images/logo-image-3.png"
              data-aos="fade-up"
            />
          </div>
          <div class="inner-right">
            <img
              class="collage"
              src="../assets/images/pizza-day.png"
              data-aos="fade-left"
            />
          </div>
        </div>
        <div class="logos__wrapper--right">
          <div class="inner-left" data-aos="fade-up">
            <h1>{{ content.logos.title }}</h1>
            <h4>{{ content.logos.subtitle }}</h4>
            <img src="../assets/images/arrow-white.svg" class="icon" />
            <p>{{ content.logos.body }}</p>
          </div>
          <div class="inner-right">
            <img
              class="card"
              v-if="!$isMobile()"
              src="../assets/images/logo-image-4.png"
              data-aos="fade-left"
            />
          </div>
        </div>
      </div>
      <logo-slider
        class="logos__slider"
        :data="content.logos.slider"
        data-aos="zoom-in"
      />
    </div>
    <div class="logo-rules">
      <img
        class="logo-rules__phone"
        src="../assets/images/disposables.png"
        data-aos="fade-up"
      />
      <div class="logo-rules__wrapper">
        <div class="logo-rules__wrapper--left">
          <h5 data-aos="fade-right">
            <img src="../assets/images/white-tick.svg" />{{
              content.logos.exclusion_zone.title
            }}
          </h5>
          <p data-aos="fade-right">{{ content.logos.exclusion_zone.body }}</p>
          <img
            src="../assets/images/logo-exclusion-zone.png"
            data-aos="fade-up"
          />
        </div>
        <div class="logo-rules__wrapper--right">
          <h5 data-aos="fade-left">
            <img src="../assets/images/white-tick.svg" />{{
              content.logos.minimum_sizes.title
            }}
          </h5>
          <p data-aos="fade-left">{{ content.logos.minimum_sizes.body }}</p>
          <img
            src="../assets/images/logo-minimum-sizes.png"
            data-aos="fade-up"
          />
        </div>
      </div>
    </div>
    <div class="typography" id="typography">
      <div class="typography__wrapper">
        <div class="typography__wrapper--left">
          <img
            class="image"
            src="../assets/images/burrito-bowl.png"
            data-aos="fade-right"
          />
          <h1 class="title" v-if="$isMobile()">
            {{ content.typography.title }}
          </h1>
        </div>
        <div class="typography__wrapper--right">
          <h1 class="title" v-if="!$isMobile()">
            {{ content.typography.title }}
          </h1>
          <div class="content">
            <h4 data-aos="fade-left">{{ content.typography.subtitle }}</h4>
            <img src="../assets/images/arrow-black.svg" class="icon" />
            <p data-aos="fade-up">
              {{ content.typography.body }}
            </p>
            <a
              class="button"
              href="https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/jet-fonts.zip"
              target="_blank"
              download
            >
              {{ content.typography.button }}
            </a>
          </div>
        </div>
      </div>
      <type-sandbox :data="content.typography.sandbox" />
      <div class="typography__digital">
        <div class="typography__digital--left">
          <h5>Digital typeface</h5>
          <p>We've also developed an optimised sub-family of fonts for our digital channels. The sub-family will allow us to stay consistent across all major touchpoints, and increase readability for our audiences.</p>
          <a class="button" href="https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/jet-sans-digital.zip" target="_blank" download>Download JET Sans Digital</a>
        </div>
        <div class="typography__digital--right">
          <img src="../assets/images/JET-Sans-digital.svg" >
        </div>
      </div>
      <div class="typography__alignment">
        <div class="typography__alignment--left">
          <img
            class="gif"
            src="../assets/images/typography-alignment.gif"
            data-aos="fade-right"
          />
          <h5 v-if="$isMobile()" data-aos="fade-left">
            {{ content.typography.alignment.title }}
          </h5>
          <p v-if="$isMobile()" data-aos="fade-left">
            {{ content.typography.alignment.body }}
          </p>
          <img
            class="woman"
            src="../assets/images/recently-moved.png"
            data-aos="fade-right"
          />
          <img
            class="drink"
            src="../assets/images/drink-charcoal.svg"
            data-aos="fade-right"
          />
        </div>
        <div class="typography__alignment--right">
          <h5 v-if="!$isMobile()" data-aos="fade-left">
            {{ content.typography.alignment.title }}
          </h5>
          <p v-if="!$isMobile()" data-aos="fade-left">
            {{ content.typography.alignment.body }}
          </p>
          <img
            class="sandwich"
            src="../assets/images/burger-charcoal.svg"
            data-aos="fade-left"
          />
          <img
            class="sushi"
            src="../assets/images/sushi-charcoal.svg"
            data-aos="fade-left"
          />
          <img
            class="nachos"
            src="../assets/images/nachos-charcoal.svg"
            data-aos="fade-up"
          />
        </div>
      </div>
    </div>
    <div class="colours" id="colours">
      <h1 class="colours__title" data-aos="fade-up">
        {{ content.colours.title }}
      </h1>
      <div class="colours__wrapper">
        <div class="colours__wrapper--left">
          <h4 class="title" data-aos="fade-up">
            {{ content.colours.intro.title }}
          </h4>
          <img class="arrow" src="../assets/images/white-arrow-down.svg" />
          <p class="body" data-aos="fade-up">
            {{ content.colours.intro.body }}
          </p>
          <colour-card
            class="card"
            :content="content.colours.orange_card"
            data-aos="fade-right"
          />
        </div>
        <div class="colours__wrapper--right">
          <colour-card
            class="card"
            v-for="(card, i) in content.colours.cards"
            :key="`card_${i}`"
            :content="card"
            data-aos="zoom-in"
          />
          <div class="supporting">
            <h5 data-aos="fade-left">{{ content.colours.supporting.title }}</h5>
            <p data-aos="fade-left">{{ content.colours.supporting.body }}</p>
          </div>
        </div>
      </div>
      <div class="colours__footer">
        <div class="colours__footer--left">
          <img
            class="base"
            src="../assets/images/base-colours.png"
            data-aos="fade-up"
          />
          <h5 data-aos="fade-right">
            <img src="../assets/images/yes-check.svg" />{{
              content.colours.base.title
            }}
          </h5>
          <p data-aos="fade-right">{{ content.colours.base.body }}</p>
        </div>
        <div class="colours__footer--right">
          <img
            class="circle"
            src="../assets/images/colour-how-much-orange.gif"
            data-aos="fade-up"
          />
          <h5 data-aos="fade-left">
            <img src="../assets/images/yes-check.svg" />{{
              content.colours.how_much.title
            }}
          </h5>
          <p data-aos="fade-left">{{ content.colours.how_much.body_1 }}</p>
          <p data-aos="fade-left">{{ content.colours.how_much.body_2 }}</p>
        </div>
      </div>
    </div>
    <div class="composition" id="composition">
      <h1 class="composition__title">{{ content.composition.title }}</h1>
      <div class="composition__intro">
        <div class="composition__intro--image">
          <img src="../assets/images/milkshakes.png" data-aos="fade-up" />
        </div>
        <div class="composition__intro--subtitle">
          <h4 data-aos="fade-left">{{ content.composition.subtitle }}</h4>
          <img
            src="../assets/images/arrow-black.svg"
            class="icon"
            data-aos="fade-left"
          />
        </div>
      </div>
      <div class="composition__grids">
        <div class="composition__grids--content">
          <h5>{{ content.composition.grids.title }}</h5>
          <p
            v-for="(item, i) in content.composition.grids.content"
            :key="`grid_${i}`"
            :class="item.strong && 'strong'"
            data-aos="fade-right"
          >
            {{ item.text }}
          </p>
        </div>
        <img
          class="composition__grids--animation"
          src="../assets/images/composition-grid-animation.gif"
          data-aos="fade-left"
        />
      </div>
      <div class="composition__cards">
        <img
          class="composition__cards--animation"
          src="../assets/images/composition-cards-animation.gif"
          data-aos="fade-right"
        />
        <div class="composition__cards--content">
          <h5>{{ content.composition.cards.title }}</h5>
          <p
            v-for="(item, i) in content.composition.cards.content"
            :key="`grid_${i}`"
            :class="item.strong && 'strong'"
            data-aos="fade-left"
          >
            {{ item.text }}
          </p>
        </div>
      </div>
      <div class="composition__razor">
        <div class="composition__razor--content">
          <h5>{{ content.composition.razor.title }}</h5>
          <p
            v-for="(item, i) in content.composition.razor.content"
            :key="`grid_${i}`"
            :class="item.strong && 'strong'"
            data-aos="fade-right"
            :style="
              i === content.composition.razor.content.length - 1 &&
              'margin-top: 20px;'
            "
          >
            {{ item.text }}
          </p>
        </div>
        <img
          class="composition__razor--animation"
          src="../assets/images/composition-razor-animation.gif"
          data-aos="fade-left"
        />
      </div>
    </div>
    <div class="icons" id="icons">
      <div class="icons__intro">
        <div class="icons__intro--left">
          <img src="../assets/images/sushi-image.png" data-aos="fade-right" />
        </div>
        <div class="icons__intro--right">
          <h1 data-aos="fade-up">{{ content.icons.title }}</h1>
          <h4 data-aos="fade-left">{{ content.icons.subtitle }}</h4>
          <img
            src="../assets/images/arrow-black.svg"
            class="icon"
            data-aos="fade-left"
          />
          <p
            :class="item.strong && 'strong'"
            :style="item.strong && 'margin-bottom: -10px;'"
            v-for="(item, i) in content.icons.body"
            :key="`body_${i}`"
            data-aos="fade-left"
          >
            {{ item.text }}
          </p>
        </div>
      </div>
      <div class="icons__images">
        <img
          class="icons__images--left"
          src="../assets/images/custom-grid.png"
          data-aos="fade-up"
        />
        <img
          class="icons__images--right"
          src="../assets/images/icon-base.png"
          data-aos="fade-up"
        />
      </div>
      <div class="icons__keyboard">
        <h4 data-aos="fade-up">{{ content.icons.picker_title }}</h4>
        <icon-keyboard
          :icons="content.icons.icon_list"
          :colours="content.icons.colour_list"
          data-aos="zoom-in"
        />
      </div>
    </div>
    <img class="promotional-razor" src="../assets/images/orange-razor.png" />
    <div class="promotional">
      <div class="promotional__top">
        <img
          class="promotional__top--image"
          src="../assets/images/dounuts.png"
          data-aos="fade-right"
        />
        <div class="promotional__top--text">
          <h5 data-aos="fade-left">{{ content.promotional.title }}</h5>
          <p data-aos="fade-left">{{ content.promotional.body_1 }}</p>
        </div>
      </div>
      <div class="promotional__bottom">
        <p class="promotional__bottom--text" data-aos="fade-right">
          {{ content.promotional.body_2 }}
        </p>
        <img
          class="promotional__bottom--image"
          src="../assets/images/burger.png"
          data-aos="fade-left"
        />
      </div>
    </div>
    <div class="illustration" id="illustration">
      <h1 data-aos="fade-up">{{ content.illustration.title }}</h1>
      <div class="illustration__wrapper">
        <div class="illustration__wrapper--left">
          <img src="../assets/images/Complex-Wrap.png" data-aos="fade-right" />
        </div>
        <div class="illustration__wrapper--right">
          <h5 data-aos="fade-left">{{ content.illustration.subtitle }}</h5>
          <img
            src="../assets/images/arrow-black.svg"
            class="icon"
            data-aos="fade-left"
          />
          <p data-aos="fade-left">
            {{ content.illustration.body_1 }}
          </p>
          <p data-aos="fade-left">
            {{ content.illustration.body_2 }}
          </p>
        </div>
      </div>
      <h4>{{ content.illustration.spinners.title }}</h4>
      <div class="illustration__spinners">
        <div
          v-for="(spinner, i) in content.illustration.spinners.gifs"
          :key="`spinner_${i}`"
          class="illustration__spinners--spinner"
        >
          <img
            :src="require(`../assets/images/${spinner.image}.gif`)"
            data-aos="zoom-in"
          />
          <p>{{ spinner.text }}</p>
        </div>
      </div>
    </div>
    <div class="illustration-usage">
      <div class="illustration-usage__wrapper">
        <div class="illustration-usage__wrapper--left">
          <img
            src="../assets/images/illustration-simple-and-complex.png"
            data-aos="fade-up"
          />
          <h5 data-aos="fade-right">
            <img src="../assets/images/yes-check.svg" />{{
              content.illustration.versus.title
            }}
          </h5>
          <p data-aos="fade-right">
            <strong>{{ content.illustration.versus.subtitle_1 }}</strong>
          </p>
          <p data-aos="fade-right">{{ content.illustration.versus.body_1 }}</p>
          <p data-aos="fade-right">
            <strong>{{ content.illustration.versus.subtitle_2 }}</strong>
          </p>
          <p data-aos="fade-right">{{ content.illustration.versus.body_2 }}</p>
        </div>
        <div class="illustration-usage__wrapper--right">
          <img
            src="../assets/images/illustration-colours.png"
            data-aos="fade-up"
          />
          <h5 data-aos="fade-left">
            <img src="../assets/images/yes-check.svg" />{{
              content.illustration.additional.title
            }}
          </h5>
          <p data-aos="fade-right">
            {{ content.illustration.additional.body_1 }}
          </p>
          <p data-aos="fade-right">
            {{ content.illustration.additional.body_2 }}
          </p>
        </div>
      </div>
      <illustration-gallery
        class="illustration-usage__gallery"
        :content="content.illustration.library"
      />
    </div>
    <div class="photography" id="photography">
      <h1 data-aos="fade-up">{{ content.photography.title_1 }}</h1>
      <h1 data-aos="fade-up">{{ content.photography.title_2 }}</h1>
      <div class="photography__intro">
        <h5 data-aos="fade-right">{{ content.photography.subtitle }}</h5>
        <img
          src="../assets/images/arrow-white.svg"
          class="icon"
          data-aos="fade-right"
        />
        <p data-aos="fade-right">{{ content.photography.body }}</p>
      </div>
      <div class="photography__group">
      <div class="photography__items">
        <div
          class="photography__items--box"
          v-for="(type, i) in content.photography.types"
          :key="`type_${i}`"
        >
          <img
            :src="require(`../assets/images/${type.image}.png`)"
            data-aos="fade-up"
          />
          <!-- <h5 data-aos="fade-up">{{ type.title }}</h5> -->
        </div>
      </div>
      <img
        class="photography__arrow"
        src="../assets/images/photo-spectrum-line.png"
      />
      <div class="photography__lists">
        <ul
          class="photography__lists--box"
          v-for="(list, i) in content.photography.lists"
          :key="`list_${i}`"
        >
        <h5>{{ list.title }}</h5>
          <li
            v-for="(item, i) in list.items"
            :key="`list_${i}`"
            data-aos="fade-up"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      </div>
    </div>
    <div class="studio-photography">
      <div class="studio-photography__intro">
        <div class="studio-photography__intro--left">
          <img src="../assets/images/pizza-plate.png" data-aos="fade-right" />
        </div>
        <div class="studio-photography__intro--right">
          <h5 data-aos="fade-left">
            {{ content.photography.studio.intro.title }}
          </h5>
          <p data-aos="fade-left">
            {{ content.photography.studio.intro.body }}
          </p>
          <a
            class="button"
            :href="content.photography.studio.intro.link"
            target="_blank"
            >{{ content.photography.studio.intro.button }}</a
          >
        </div>
      </div>
      <div class="studio-photography__examples">
        <h2 data-aos="fade-up">{{ content.photography.studio.title }}</h2>
        <img
          src="../assets/images/photo-studio-carousel.gif"
          data-aos="fade-up"
        />
      </div>
      <div class="studio-photography__tips">
        <div
          v-for="(tip, i) in content.photography.studio.tips"
          :key="`tip_${i}`"
          class="studio-photography__tips--column"
        >
          <h5 data-aos="fade-up">
            <img src="../assets/images/white-tick.svg" />{{ tip.title }}
          </h5>
          <p data-aos="fade-up">{{ tip.body_1 }}</p>
          <p data-aos="fade-up">{{ tip.body_2 }}</p>
          <div
            data-aos="fade-up"
            :style="`background-image: url(${require(`../assets/images/${tip.image}`)})`"
          ></div>
        </div>
      </div>
    </div>
    <div class="photography-positioning">
      <div class="photography-positioning__container">
        <h4 data-aos="fade-up">{{ content.photography.position.title }}</h4>
        <razor-calibrator
          data-aos="zoom-in"
          class="photography-positioning__razor"
          :content="content.photography.position"
        />
        <div class="photography-positioning__rotation">
          <div class="photography-positioning__rotation--left">
            <img
              src="../assets/images/photo-studio-atl-btl.png"
              data-aos="fade-right"
            />
          </div>
          <div class="photography-positioning__rotation--right">
            <h5 data-aos="fade-left">
              {{ content.photography.position.above.title }}
            </h5>
            <p data-aos="fade-left">
              {{ content.photography.position.above.body_1 }}
            </p>
            <p data-aos="fade-left">
              {{ content.photography.position.above.body_2 }}
            </p>
            <ul>
              <li
                v-for="(above, i) in content.photography.position.above.list"
                :key="`above_${i}`"
                data-aos="fade-left"
              >
                <p>{{ above }}</p>
              </li>
            </ul>
            <br />
            <br />
            <br />
            <br />
            <br />
            <h5 data-aos="fade-left">
              {{ content.photography.position.below.title }}
            </h5>
            <p data-aos="fade-left">
              {{ content.photography.position.below.body_1 }}
            </p>
            <ul>
              <li
                v-for="(below, i) in content.photography.position.below.list"
                :key="`below_${i}`"
                data-aos="fade-left"
              >
                <p>{{ below }}</p>
              </li>
            </ul>
          </div>
      </div>
      </div>
      <div class="photography-positioning__hybrid">
        <div class="photography-positioning__hybrid--left">
          <h5>Hybrid photography</h5>
          <p>Hybrid photography is where studio photography meets lifestyle photography. It gives us the opportunity to showcase a larger range of offers with an ownable style that customers will associate with JET.</p>
          <a class="button" href="" target="_blank">Browse the Vault</a>
        </div>
        <div class="photography-positioning__hybrid__image">
          <img src="../assets/images/hybrid-image-1.png" class="full">
          <img src="../assets/images/hybrid-image-2.png" class="half">
        <img src="../assets/images/hybrid-image-3.png" class="half">
        </div>
      </div>
      <div class="photography-positioning__container">
      <div class="photography-positioning__lifestyle">
        <div
          class="photography-positioning__lifestyle--mission"
          data-aos="fade-up"
        >
          <h5>{{ content.photography.lifestyle.title }}</h5>
          <p>{{ content.photography.lifestyle.body_1 }}</p>
          <p>{{ content.photography.lifestyle.body_2 }}</p>
          <a
            class="button"
            :href="content.photography.lifestyle.link"
            target="_blank"
            >{{ content.photography.lifestyle.button }}</a
          >
        </div>
        <h2
          class="photography-positioning__lifestyle--headline"
          data-aos="zoom-in"
        >
          {{ content.photography.lifestyle.subtitle }}
        </h2>
        <div class="photography-positioning__lifestyle--sections">
          <div
            v-for="(section, i) in content.photography.lifestyle.sections"
            :key="`section_${i}`"
            class="section"
            data-aos="fade-left"
          >
            <div class="container">
              <div
                class="image"
                :style="`background-image: url(${require(`../assets/images/${section.image}.png`)});`"
              ></div>
              <div class="body" :class="section.color">
                <div v-if="section.body_1.length > 0">
                  <h5 :style="`color: var(--color-${section.text}-1)`">
                    {{ section.title }}
                  </h5>
                  <p :style="`color: var(--color-${section.text}-1)`">
                    {{ section.body_1 }}
                  </p>
                  <p :style="`color: var(--color-${section.text}-1)`">
                    {{ section.body_2 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div
      class="photography-shoots"
      :style="`background-image: url(${require(`../assets/images/${content.photography.shoots[shootId].image}.png`)});`"
    >
      <div class="photography-shoots__nav" data-aos="fade-up">
        <div
          v-for="(shoot, i) in content.photography.shoots"
          :key="`shoot_${i}`"
          :class="shootId === i && 'outline'"
          class="photography-shoots__nav--item button"
          @click="shootId = i"
        >
          {{ shoot.nav }}
        </div>
      </div>
      <div class="photography-shoots__box" data-aos="fade-left">
        <h5>
          {{ content.photography.shoots[shootId].title_1 }}
        </h5>
        <p>
          {{ content.photography.shoots[shootId].body_1 }}
        </p>
        <h5>
          {{ content.photography.shoots[shootId].title_2 }}
        </h5>
        <p>
          {{ content.photography.shoots[shootId].body_2 }}
        </p>
      </div>
    </div>
    <div class="moving-photography">
      <div class="moving-photography__intro" data-aos="fade-right">
        <div class="moving-photography__intro--info">
          <h5>
            {{ content.photography.moving.intro.title }}
          </h5>
          <p>{{ content.photography.moving.intro.body }}</p>
          <a
            class="button"
            :href="content.photography.moving.intro.link"
            target="_blank"
            >{{ content.photography.moving.intro.button }}</a
          >
        </div>
      </div>
      <h2 class="moving-photography__title" data-aos="zoom-in">
        {{ content.photography.moving.title }}
      </h2>
      <div class="moving-photography__video">
        <video autoplay loop muted>
          <source src="../assets/images/hero-video-more-2024.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
    <div class="co-branding" id="co-branding">
      <div
        v-for="(icon, i) in content.co_branding.icons"
        :key="`icon_${i}`"
        class="co-branding__icons"
        :style="`top: ${!$isMobile() ? icon.top : icon.mobile.top}%; left: ${
          !$isMobile() ? icon.left : icon.mobile.left
        }%`"
        :data-aos="icon.animate"
      >
        <img :src="require(`../assets/images/${icon.name}.png`)" />
      </div>
      <div class="co-branding__wrapper">
        <h1 class="co-branding__wrapper--title">
          {{ content.co_branding.title }}
        </h1>
        <div class="co-branding__wrapper--intro">
          <h5 data-aos="fade-up">{{ content.co_branding.intro.title }}</h5>
          <img
            src="../assets/images/arrow-black.svg"
            class="icon"
            data-aos="fade-left"
          />
          <p data-aos="fade-up">
            {{ content.co_branding.intro.body_1 }}
          </p>
          <p data-aos="fade-up">
            {{ content.co_branding.intro.body_2 }}
          </p>
        </div>
      </div>
    </div>
    <div class="our-world">
      <h4 class="our-world__title" data-aos="fade-up">
        {{ content.our_world.title }}
      </h4>
      <branding-carousel
        :slides="content.our_world.slides"
        data-aos="zoom-in"
      />
    </div>
    <div class="partner-world">
      <h4 class="partner-world__title" data-aos="fade-up">
        {{ content.partner_world.title }}
      </h4>
      <branding-carousel
        :slides="content.partner_world.slides"
        data-aos="zoom-in"
      />
    </div>
    <div class="co-branding-world">
      <div class="co-branding-world__left">
        <h5>This is how we co-brand in a shared brand world</h5>
        <p>When the funding for a campaign is split between us and our partners, we create a shared brand world.</p>
        <p>In this world, all Restaurant Partner menu items should be shot or retouched in our art direction style. For lifestyle imagery, we use a brand frame. This allows us to add our branding to images that would have otherwise been full-bleed. Make sure the image doesn’t contain any text or logos before adding the frame.</p>
        <p>When designing in large and medium formats, including OOH, our logo should always be placed at the top of the layout.</p>
      </div>
      <div class="co-branding-world__right">
        <img src="../assets/images/cobrandingnew.png" alt="">
      </div>
    </div>
    <div class="brand-lockup">
      <div class="brand-lockup__left">
        <img
          src="../assets/images/co-branding-logos-intro.png"
          data-aos="fade-right"
        />
      </div>
      <div class="brand-lockup__right">
        <h5 data-aos="fade-left">{{ content.brand_lockup.title }}</h5>
        <p data-aos="fade-left">{{ content.brand_lockup.body_1 }}</p>
        <p data-aos="fade-left">{{ content.brand_lockup.body_2 }}</p>
        <img
          src="../assets/images/co-branding-logos-primary.png"
          data-aos="fade-left"
        />
      </div>
    </div>
    <div class="secondary-lockup">
      <div class="secondary-lockup__left">
        <h5 data-aos="fade-right">{{ content.secondary_lockup.title }}</h5>
        <p data-aos="fade-right">{{ content.secondary_lockup.body_1 }}</p>
        <p data-aos="fade-right">{{ content.secondary_lockup.body_2 }}</p>
      </div>
      <div class="secondary-lockup__right">
        <img
          src="../assets/images/co-branding-logos-secondary.gif"
          data-aos="fade-up"
        />
      </div>
    </div>
    <div class="other-logos">
      <div class="other-logos__left">
        <img src="../assets/images/co-branding-orange-background.png" />
        <h5 data-aos="fade-right">
          <img src="../assets/images/white-tick.svg" />
          {{ content.secondary_lockup.orange.title }}
        </h5>
        <p data-aos="fade-right">
          {{ content.secondary_lockup.orange.body }}
        </p>
      </div>
      <div class="other-logos__right">
        <img src="../assets/images/co-branding-tab.gif" data-aos="fade-left" />
        <h5 data-aos="fade-left">
          <img src="../assets/images/white-tick.svg" />
          {{ content.secondary_lockup.tab.title }}
        </h5>
        <p data-aos="fade-left">{{ content.secondary_lockup.tab.body }}</p>
      </div>
    </div>
    <div class="footer">
      <p class="footer__body">
        {{ content.footer.body_1
        }}<a
          class="footer__body--link"
          :href="`mailto:${content.footer.link_1}`"
          target="_blank"
          >{{ content.footer.link_1 }}</a
        >{{ content.footer.body_2 }}
      </p>
      <p class="footer__body">
        {{ content.footer.body_3
        }}<a
          class="footer__body--link"
          :href="content.footer.url"
          target="_blank"
          >{{ content.footer.link_2 }}</a
        >
      </p>
    </div>
  </section>
</template>

<script>
import NavBar from '../components/NavBar'
import SiteMap from '../components/SiteMap'
import LogoSlider from '../components/LogoSlider'
import TypeSandbox from '../components/TypeSandbox'
import ColourCard from '../components/ColourCard'
import IconKeyboard from '../components/IconKeyboard'
import IllustrationGallery from '../components/IllustrationGallery'
import Content from '../data/content'
import BrandingCarousel from '../components/BrandingCarousel.vue'
import RazorCalibrator from '../components/RazorCalibrator.vue'

export default {
  name: 'More',
  components: {
    NavBar,
    SiteMap,
    LogoSlider,
    TypeSandbox,
    ColourCard,
    IconKeyboard,
    IllustrationGallery,
    BrandingCarousel,
    RazorCalibrator,
  },
  data() {
    return {
      content: Content.more,
      siteMapOpen: false,
      scrollHeight: false,
      shootId: 0,
    }
  },
  computed: {
    isOrange() {
      if (
        (this.scrollHeight >= 0 && this.scrollHeight < 936) ||
        (this.scrollHeight >= 4800 && this.scrollHeight < 5510)
      ) {
        return true
      }
      return false
    },
    textColour() {
      return this.isOrange ? 'orange' : 'orange'
    },
    backgroundColour() {
      return this.isOrange ? 'white' : 'white'
    },
    logoType() {
      if (this.scrollHeight >= 0 && this.scrollHeight < 816)
        return 'logo-orange'
      return this.isOrange ? 'house-orange' : 'house-orange'
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(event) {
      this.scrollHeight = event.target.documentElement.scrollTop
    },
    toggleSiteMap(val) {
      this.siteMapOpen = val
    },
  },
}
</script>

<style lang="scss">
$desktop: 1450px;
$tablet: 768px;
$mobile: 600px;

.more-hero {
  &__title {
    color: var(--color-white-1);
    text-align: center;
    margin: -550px 0 400px;
    position: relative;
    @media (max-width: $tablet) {
      margin: -600px 0 300px;
    }
  }
}
.intro {
  width: 60%;
  padding: 160px 20% 60px;
  display: flex;
  align-items: center;
  background-color: var(--color-mozzarella-1);
  @media (max-width: $tablet) {
    width: 100%;
    padding: 0;
    flex-direction: column;
  }
  &__left {
    width: 40%;
    @media (max-width: $tablet) {
      width: 90%;
    }
    &--title,
    &--body {
      color: var(--color-charcoal-1);
    }
    a {
      color: var(--color-charcoal-1);
      display: inline-block;
      margin-top: 20px;
    }
  }
  &__right {
    text-align: center;
    width: 60%;
    @media (max-width: $tablet) {
      width: 90%;
    }
    &--image {
      width: 80%;
      @media (max-width: $tablet) {
        margin: 40px 0;
        width: 90%;
      }
    }
  }
}
.logo-razor {
  @media (max-width: $tablet) {
    margin-top: -400px;
  }
}
.logos {
  background-color: var(--color-orange-1);
  width: 100%;
  margin-top: -50px;
  &__wrapper {
    display: flex;
    align-items: center;
    @media (max-width: $tablet) {
      flex-direction: column;
      padding-top: 300px;
    }
    &--left,
    &--right {
      display: flex;
    }
    &--left {
      margin: -800px 0 0 15%;
      align-items: center;
      @media (max-width: $tablet) {
        padding: 0;
        margin: -550px 0 0 15%;
      }
      .inner-left {
        text-align: right;
        width: 50%;
        @media (max-width: $tablet) {
          width: 70%;
        }
        .woman {
          width: 70%;
          margin-right: 20px;
          border-radius: 30px;
        }
        .bikes {
          width: 100%;
          margin-right: 20px;
        }
      }
      .inner-right {
        width: 50%;
        .collage {
          width: 50%;
          margin-right: 20px;
          @media (max-width: $tablet) {
            width: 100%;
          }
        }
      }
    }
    &--right {
      align-items: flex-end;
      padding: 0 20% 0 0;
      margin: -200px 0 0 -20%;
      @media (max-width: $tablet) {
        padding: 0;
        margin: 0 5%;
      }
      .inner-left {
        width: 50%;
        @media (max-width: $tablet) {
          width: 100%;
          h1 {
            margin: 0;
          }
        }
        h1,
        p,
        h4,
        h3 {
          color: var(--color-white-1);
        }
        img {
          width: 40px;
        }
      }
      .inner-right {
        width: 50%;
        .card {
          width: 100%;
          margin-left: 20px;
          margin-left: 75%;
        }
      }
    }
  }
  &__slider {
    background-color: var(--color-orange-1);
    width: 80%;
    padding: 100px 10% 235px;
    @media (max-width: $tablet) {
      padding: 50px 10%;
    }
  }
}
.logo-rules {
  background-color: var(--color-orange-1);
  color: var(--color-white-1);
  &__phone {
    width: 20%;
    margin: -185px 40%;
    z-index: 1;
    position: relative;
    @media (max-width: $tablet) {
      margin: -85px 50%;
      width: 40%;
    }
  }
  &__wrapper {
    display: flex;
    @media (max-width: $tablet) {
      flex-direction: column;
      padding: 50px 0;
    }
    &--left,
    &--right {
      width: 30%;
      padding: 300px 10%;
      @media (max-width: $tablet) {
        width: 80%;
        padding: 50px 10%;
      }
      img {
        width: 100%;
        margin: 50px auto;
        @media (max-width: $tablet) {
          width: 100%;
          margin: 20px 0;
        }
      }
      h5 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: var(--color-white-1);
        img {
          width: 40px;
          margin: 0 10px 0 0;
          padding: 0;
          color: var(--color-charcoal-1);
        }
      }
      p {
        color: var(--color-white-1);
      }
    }
  }
}
.typography {
  background-color: var(--color-turmeric-1);
  padding: 0 10%;
  &__wrapper {
    display: flex;
    align-items: center;
    z-index: 0;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left {
      width: 60%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      .image {
        width: 100%;
      }
      .title {
        transform: rotate(90deg);
        margin: 100px -150px 0 0;
        padding: 0;
        color: var(--color-charcoal-1);
        @media (max-width: $tablet) {
          margin: 100px -260px 0 0;
        }
      }
      .content {
        width: 40%;
        float: right;
        margin-top: -100px;
        @media (max-width: $tablet) {
          width: 100%;
          float: none;
          margin-top: 300px;
        }
        p {
          margin-bottom: 50px;
          color: (--color-charcoal-1);
        }
      }
    }
    &--right {
      display: flex;
      align-items: flex-end;
      display: flex;
      align-items: flex-start;
      width: 40%;
      justify-content: flex-end;
      @media (max-width: $desktop) {
        width: 65%;
        margin-top: -240px;
        margin-bottom: 30px;
      }
      .title {
        transform: rotate(90deg);
        margin-top: 15%;
        margin-right: -25%;
        color: var(--color-charcoal-1);
        @media (max-width: $desktop) {
          margin-right: -20%;
          margin-top: 40%;
        }
      }
      .content {
        margin-right: 10%;
        margin-left: -10%;
        @media (max-width: $desktop) {
          margin-top: 350px;
        }
        img {
          width: 30px;
        }
        P {
          margin-bottom: 40px;
        }
      }
    }
  }
  &__digital {
    display: flex;
    flex-wrap: wrap;
    padding-top: 100px;

    &--left {
      widtH: 30%;
      margin: 0 5%;

      @media (max-width: $tablet) {
        width: 100%;
      }

      p {
        max-width: 350px;
      }
    }

    &--right {
      width: calc(70% - 10%);
      text-align: center;
      display: flex;
      align-items: center;

      @media (max-width: $tablet) {
        width: 100%;
        margin-top: 30px;
      }

      img {
        width: 100%;

        @media (max-width: $tablet) {

        }
      }
    }
  }
  &__alignment {
    display: flex;

    @media (max-width: $tablet) {
      flex-direction: column;
    }

    &--left {
      margin: 150px 5%;
      width: 70%;
      @media (max-width: $tablet) {
        width: 100%;
        margin: 50px 0;
      }
      .gif {
        width: 100%;
        border-radius: 30px;
      }
      .woman {
        width: 75%;
        margin-top: 30px;
        border-radius: 30px;
        float: right;
        margin-right: -100px;
      }
      .ramen {
        width: 40%;
        margin-top: 30px;
      }
      .drink {
        margin-left: 15%;
        margin-top: 100px;
        display: block;
      }
    }
    &--right {
      margin: 170px 5%;
      width: 30%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      .sandwich,
      .sushi,
      .nachos {
        display: block;
        svg {
          color: white;
        }
      }
      .sandwich {
        float: right;
        margin-top: 40px;
        @media (max-width: $tablet) {
          margin-top: -100px;
        }
      }
      .sushi {
        margin-top: 400px;
        @media (max-width: $tablet) {
          margin-top: -100px;
        }
      }
      .nachos {
        margin-top: 100px;
        margin-left: 50%;
        @media (max-width: $tablet) {
          margin-top: 100px;
        }
      }
    }
  }
}
.colours {
  padding: 0 0 160px;
  &__title {
    margin-left: 50%;
    margin-bottom: 100px;
    color: var(--color-charcoal-1);
    @media (max-width: $tablet) {
      margin-left: 0;
    }
  }
  &__wrapper {
    margin-top: -200px;
    background-image: url('../assets/images/colours-bg.png');
    width: 100%;
    display: flex;
    padding-bottom: 200px;
    @media (max-width: $tablet) {
      flex-direction: column;
      background-size: cover;
      padding-bottom: 0;
      margin-top: -100px;
    }
    &--left {
      padding: 100px 5%;
      width: 20%;
      @media (max-width: $tablet) {
        width: 90%;
        padding: 50px 5%;
      }
      .title {
        color: var(--color-white-1);
      }
      .arrow {
        width: 20px;
      }
      .card {
        margin-top: 300px;
        @media (max-width: $tablet) {
          margin-top: 50px;
        }
      }
      .body {
        color: var(--color-white-1);
      }
    }
    &--right {
      width: 65%;
      padding: 200px 5% 0 0;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-evenly;
      margin-top: 100px;
      @media (max-width: $tablet) {
        width: 90%;
        padding: 50px 5%;
        margin-top: 0;
      }
      .card {
        width: 26%;
        margin: 2%;
        @media (max-width: $tablet) {
          width: 100%;
          margin: 50px 2%;
        }
      }
      .supporting {
        margin: 50px 10% 0 40%;
        width: 50%;
        color: var(--color-charcoal-1);
        @media (max-width: $tablet) {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  &__footer {
    display: flex;
    align-items: flex-start;
    background-color: var(--color-mozzarella-1);
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left,
    &--right {
      width: 30%;
      padding: 0 10%;
      @media (max-width: $tablet) {
        width: 90%;
        padding: 0 5%;
      }
      .base {
        width: 100%;
      }
      .circle {
        width: 80%;
        @media (max-width: $tablet) {
          width: 100%;
        }
      }
      h5 {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          margin: 0 10px 0 0;
        }
      }
    }
  }
}
.composition {
  background-color: var(--color-cupcake-1);
  padding: 0 10% 200px;
  @media (max-width: $tablet) {
    padding: 0 5% 50px;
  }
  &__title {
    width: 80%;
    padding: 100px 0 0;
    @media (max-width: $tablet) {
      width: 100%;
      margin: 0;
      word-wrap: break-word;
    }
  }
  &__intro {
    display: flex;
    @media (max-width: $tablet) {
      flex-direction: column;
      margin: 0;
    }
    &--subtitle {
      width: 20%;
      @media (max-width: $tablet) {
        width: 100%;
        display: block;
      }
      img {
        width: 30px;
      }
    }
    &--image {
      width: 20%;
      display: table;
      margin-left: -25%;
      margin-top: -300px;
      img {
      }
      @media (max-width: $tablet) {
        display: none;
      }
    }
  }

  &__grids {
    display: flex;
    align-items: center;
    margin-bottom: 100px;
    @media (max-width: $tablet) {
      flex-direction: column-reverse;
    }
    &--content {
      width: 30%;
      @media (max-width: $tablet) {
        width: 100%;
      }
    }
    &--animation {
      width: 60%;
      margin-left: 10%;
      border-radius: 30px;
      @media (max-width: $tablet) {
        width: 100%;
        margin: 50px 0;
      }
    }
  }
  &__cards {
    display: flex;
    align-items: center;
    margin-bottom: 100px;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--content {
      width: 30%;
      @media (max-width: $tablet) {
        width: 100%;
      }
    }
    &--animation {
      width: 60%;
      margin-right: 10%;
      border-radius: 30px;
      @media (max-width: $tablet) {
        width: 100%;
        margin: -50px 0 50px;
      }
    }
  }
  &__razor {
    display: flex;
    align-items: center;
    margin-bottom: 100px;
    @media (max-width: $tablet) {
      flex-direction: column-reverse;
    }
    &--content {
      width: 30%;
      @media (max-width: $tablet) {
        width: 100%;
      }
    }
    &--animation {
      width: 60%;
      margin-left: 10%;
      border-radius: 30px;
      @media (max-width: $tablet) {
        width: 100%;
        margin: -50px 0 50px;
      }
    }
  }
}
.icons {
  background-color: var(--color-mozzarella-1);
  padding-bottom: 400px;
  @media (max-width: $tablet) {
    clip-path: polygon(0 0, 100% 0%, 100% 95%, 0% 100%);
    padding-bottom: 100px;
  }
  &__intro {
    display: flex;
    align-items: center;
    padding: 0 10%;
    justify-content: space-around;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left {
      width: 50%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      img {
        width: 100%;
        @media (max-width: $tablet) {
          margin: 50px 0 -50px;
        }
      }
    }
    &--right {
      width: 35%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      h1 {
        margin-bottom: 50px;
      }
      img {
        width: 30px;
      }
    }
  }
  &__images {
    display: flex;
    align-items: center;
    padding: 0 10%;
    justify-content: space-around;
    margin: 100px 0 200px;
    @media (max-width: $tablet) {
      flex-direction: column;
      margin: 0;
    }
    &--left,
    &--right {
      width: 40%;
    }
    &--left {
      @media (max-width: $tablet) {
        width: 100%;
        margin-left: 15%;
      }
    }
    &--right {
      @media (max-width: $tablet) {
        width: 100%;
      }
    }
  }
  &__keyboard {
    width: 80%;
    margin: 0 10% -500px;
    h4 {
      text-align: center;
      margin-bottom: 100px;
    }
    @media (max-width: $tablet) {
      width: 90%;
      margin: 0 5%;
    }
  }
}
.promotional-razor {
  @media (max-width: $tablet) {
    margin-top: -600px;
  }
}
.promotional {
  background-color: var(--color-orange-1);
  padding: 0 10%;
  margin-top: -100px;
  @media (max-width: $tablet) {
    padding: 50px 5% 100px;
  }
  &__top {
    &--image {
      width: 50%;
      margin-top: -300px;
      @media (max-width: $tablet) {
        margin-top: 0;
        width: 100%;
      }
    }
    &--text {
      margin-top: -400px;
      width: 40%;
      @media (max-width: $tablet) {
        margin-top: 0;
        width: 100%;
      }
    }
    @media (max-width: $tablet) {
      flex-direction: column;
    }
  }
  &__bottom {
    &--image {
      width: 60%;
      margin-top: -100px;
      @media (max-width: $tablet) {
        margin-top: 0;
        width: 100%;
      }
    }
    &--text {
      margin-top: -100px;
      width: 40%;
      @media (max-width: $tablet) {
        margin-top: 0;
        width: 100%;
      }
    }
    @media (max-width: $tablet) {
      flex-direction: column-reverse;
    }
  }
  &__top,
  &__bottom {
    display: flex;
    position: relative;
    align-items: center;
    padding: 0 5%;
    @media (max-width: $tablet) {
      margin: 0;
      width: 90%;
    }
    &--text {
      color: var(--color-white-1);
      h5,
      p {
        color: var(--color-white-1);
      }
    }
  }
}
.illustration {
  background-color: var(--color-berry-1);
  padding: 1px 10% 100px;
  h1,
  h4 {
    text-align: center;
  }
  h1 {
    @media (max-width: $tablet) {
      font-size: 65px;
    }
  }
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 200px;
    @media (max-width: $tablet) {
      flex-direction: column;
      margin-bottom: 100px;
    }
    &--left {
      width: 50%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      img {
        width: 80%;
        @media (max-width: $tablet) {
          margin: 50px 0 100px;
          width: 100%;
        }
      }
    }
    &--right {
      width: 20%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      h1 {
        margin-bottom: 50px;
      }
      img {
        width: 20px;
      }
    }
  }
  &__spinners {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--spinner {
      text-align: center;
      width: 33.3%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      img {
        width: 95%;
      }

      p {
        padding: 0 20px;
      }
    }
  }
}
.illustration-usage {
  background-color: var(--color-mozzarella-1);
  padding: 100px 0;
  @media (max-width: $tablet) {
    padding: 100px 5%;
  }
  &__wrapper {
    display: flex;
    align-items: center;
    padding: 0 0 100px;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left,
    &--right {
      width: 30%;
      padding: 0 10%;
      @media (max-width: $tablet) {
        width: 90%;
        padding: 50px 5%;
      }
      h5 {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          margin: 0 10px 0 0;
        }
      }
    }
    &--left {
      img {
        width: 100%;
        @media (max-width: $tablet) {
          width: 90%;
          text-align: center;
        }
      }
    }
    &--right {
      img {
        width: 80%;
        @media (max-width: $tablet) {
          width: 90%;
          text-align: center;
        }
      }
    }
  }
  &__gallery {
    padding: 50px 10%;
    width: 80%;
  }
}
.photography {
  background-color: var(--color-aubergine-1);
  padding: 100px 10%;
  h1 {
    color: var(--color-white-1);
    margin: 0;
    font-size: 145px;
    @media (max-width: $tablet) {
      font-size: 55px;
      line-height: 60px;
    }
  }
  &__intro {
    width: 30%;
    margin: 100px 0;
    @media (max-width: $tablet) {
      width: 100%;
    }
    img {
      width: 40px;
    }
    h5,
    p {
      color: var(--color-white-1);
    }
  }
  &__arrow {
    width: 1%;
    @media (max-width: $tablet) {
      width: 1%;
    }
  }
  &__group {
    display: flex;
    flex-wrap: wrap;
  }
  &__items,
  &__lists {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    width: 49%;
    &--box {
      margin: 0 5% 0 0;
      @media (max-width: $tablet) {
        margin: 0 1%;
      }
      h5,
      li {
        color: var(--color-white-1);
      }
      img {
        width: 100%;
        margin-bottom: 15px;
        border-radius: 30px;
      }
      &:last-of-type {
      img {
        margin-bottom: 0;
      }
    }
    }
  }
  &__lists {
    padding: 50px 0;
    &--box {
      padding: 0;
      li {
        margin-left: 20px;
        @media (max-width: $tablet) {
          margin-left: 0;
        }
      }
    }
  }
}
.studio-photography {
  background-color: var(--color-orange-1);
  &__intro,
  &__tips {
    display: flex;
    align-items: center;
    padding: 100px 10%;
    @media (max-width: $tablet) {
      padding: 100px 5%;
      flex-direction: column;
    }
  }
  &__intro {
    &--left {
      width: 65%;
      @media (max-width: $tablet) {
        width: 90%;
      }
      img {
        width: 100%;
      }
    }
    &--right {
      width: 35%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      h5,
      p,
      a {
        color: var(--color-white-1);
      }
      a {
        border: 2px solid var(--color-white-1);
      }
      p {
        padding: 0 0 30px;
      }
      h5 {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          margin: 0 10px 0 0;
        }
      }
    }
  }
  &__tips {
    align-items: flex-start;
    &--column {
      width: 30%;
      padding: 50px 10%;
      @media (max-width: $tablet) {
        width: 90%;
        padding: 50px 5%;
      }
      h5,
      p,
      a {
        color: var(--color-white-1);
      }
      a {
        border: 2px solid var(--color-white-1);
      }
      p {
        padding: 0 0 30px;
      }
      div {
        width: 100%;
        border-radius: 30px;
        height: 300px;
        background-size: cover;
        border: 2px solid var(--color-white-1);
      }
      h5 {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          margin: 0 10px 0 0;
        }
      }
    }
  }
  &__examples {
    h2 {
      font-style: italic;
      color: var(--color-white-1);
      @media (max-width: $tablet) {
        width: 100%;
        font-size: 40px;
        text-align: center;
        line-height: 40px;
      }
    }
    img {
      width: 100%;
      margin: 0 -10%;
    }
    text-align: center;
  }
}
.photography-positioning {
  background-color: var(--color-mozzarella-2);
  // padding: 100px 10%;
  .photography-positioning__container {
    padding: 100px 10%;
  }
  h4 {
    text-align: center;
    @media (max-width: $tablet) {
      display: none;
    }
  }
  &__razor {
    margin: 50px 0 100px;
    @media (max-width: $tablet) {
      display: none;
    }
  }
  &__rotation {
    display: flex;
    padding: 100px 5%;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left {
      width: 50%;
      margin-right: 5%;
      @media (max-width: $tablet) {
        width: 100%;
        margin-right: 0;
      }
      img {
        width: 100%;
      }
    }
    &--right {
      width: 45%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      p {
        margin: 0;
      }
    }
  }

  &__hybrid {
    position: relative;
    &--left {
      padding: 0 10%;
      max-width: 375px;
      margin-bottom: 125px;
    }

    &__image {
      position: relative;
      padding: 0 10%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      img {
        border-radius: 30px;
      }

      img.full {
        width: 100%;
        margin-bottom: 30px;
      }

      img.half {
        width: calc(50% - 15px);
      }

      @media (max-width: $mobile) {
        img {
          border-radius: 15px;

          &.half {
            width: 100%;
            margin-bottom: 15px;
          }

          &.full {
            margin-bottom: 15px;
          }
        }
      }
    }

    .hybrid-photo {
      position: absolute;
      max-height: 440px;
      border-radius: 30px;
      outline: 1px solid white;

      @media (max-width: $tablet) {
        max-height: 150px;
      }

      &--top {
        top: -50%;
        right: 10%;
        transform: translateY(50%);
      }

      &--bottom {
        bottom: -10%;
        left: 20%;
      }
    }
  }
  &__lifestyle {
    &--mission {
      padding: 50px 10%;
      max-width: 375px;
      @media (max-width: $tablet) {
        padding: 50px 0;
      }
      a {
        margin-top: 20px;
      }
    }
    &--headline {
      text-align: center;
      font-style: italic;
      color: var(--color-orange-1);
      @media (max-width: $tablet) {
        width: 100%;
        font-size: 40px;
        line-height: 40px;
      }
    }
    &--sections {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .section {
        width: 33%;
        perspective: 1000px;
        height: 350px;
        overflow: hidden;
        @media (max-width: $tablet) {
          width: 100%;
        }
        &:hover {
          .container {
            transform: rotateY(180deg);
          }
        }
        .container {
          position: relative;
          text-align: center;
          transition: transform 0.6s;
          transform-style: preserve-3d;
          .image,
          .body {
            position: absolute;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            margin: 0 3%;
            background-size: cover;
            @media (max-width: $tablet) {
              margin: 3%;
            }
          }
          .image {
            border-radius: 30px;
            width: 96%;
            height: 330px;
            @media (max-width: $tablet) {
              width: 97%;
            }
          }
          .body {
            border-radius: 30px;
            padding: 20px 10% 20px 20px;
            transform: rotateY(180deg);
            height: 290px;
          }
        }
      }
    }
  }
}
.photography-shoots {
  background-size: cover;
  background-position: center;
  padding: 400px 5% 100px;
  position: relative;
  @media (max-width: $tablet) {
    padding: 400px 0 100px;
  }
  &__nav {
    display: flex;
    align-items: center;
    // margin-bottom: 300px;
    position: absolute;
    top: -30px;
    left: 10%;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--item {
      border: none;
      margin-right: 50px;
      background-color: var(--color-white-1);
      color: var(--color-charcoal-1);
      box-shadow: 0px 0px 3px var(--color-charcoal-1);
      @media (max-width: $tablet) {
        margin-right: 0;
        margin-bottom: 20px;
        width: 80%;
        text-align: center;
      }
    }
  }
  &__box {
    padding: 10px 40px 20px;
    margin-left: 65%;
    width: 30%;
    background-color: var(--color-mozzarella-2);
    border-radius: 30px;
    @media (max-width: $tablet) {
      width: 70%;
      margin: 50px 5%;
    }
  }
}
.moving-photography {
  background-color: var(--color-tomato-1);
  padding: 100px 10%;
  &__intro {
    display: flex;
    align-items: center;
    margin-bottom: 100px;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--info {
      margin-left: 5%;
      width: 30%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      h5,
      p,
      a {
        color: var(--color-white-1);
      }
      a {
        margin-top: 20px;
        border: 2px solid var(--color-white-1);
      }
    }
  }
  &__title {
    color: var(--color-white-1);
    text-align: center;
    font-style: italic;
    width: 100%;
    @media (max-width: $tablet) {
      font-size: 40px;
      line-height: 40px;
      margin: 80px 0 0;
    }
  }
  &__video {
    width: 100%;
    video {
      width: 100%;
      border-radius: 30px;
      margin-bottom: 150px;
      border: 2px solid var(--color-white-1);
    }
  }
}
.co-branding {
  position: relative;
  height: 1200px;
  background-color: var(--color-mozzarella-1);
  @media (max-width: $tablet) {
    height: 500px;
    margin-bottom: 50px;
  }
  &__icons {
    position: absolute;
    img {
      width: 120px;
      @media (max-width: $tablet) {
        width: 70px;
      }
    }
  }
  &__wrapper {
    display: flex;
    margin-left: 25%;
    padding: 80px 0 0;
    width: 60%;
    img {
      width: 20px;
    }
    @media (max-width: $tablet) {
      flex-direction: column;
      margin-left: 0;
      padding: 0 10%;
    }
    &--title {
      transform: rotate(90deg);
      color: var(--color-charcoal-1);
      position: absolute;
      top: 200px;
      left: 0;
      @media (max-width: $tablet) {
        transform: rotate(0deg);
        font-size: 40px;
        line-height: 40px;
        text-align: center;
        position: relative;
        top: 0;
      }
    }
    &--intro {
      width: 30%;
      margin-left: 30%;
      @media (max-width: $tablet) {
        margin-left: 0;
        width: 100%;
      }
    }
  }
}
.our-world,
.partner-world, .logo-world {
  background-color: var(--color-mozzarella-1);
  padding: 100px 10%;
  @media (max-width: $tablet) {
    padding: 50px 5%;
  }
  &__title {
    text-align: center;
  }
}
.co-branding-world {
  background-color: var(--color-mozzarella-1);
    padding: 100px 10%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

  @media (max-width: $tablet) {
    display: block;
  }

    &__left {
      width: 29%;
      @media (max-width: $tablet) {
        width: 100%;
  }
    }

    &__right {
      width: 69%;
      @media (max-width: $tablet) {
        widtH: 100%;
  }

      img {
        width: 100%;
      }
    }
}
.brand-lockup {
  background-color: var(--color-turmeric-1);
  padding: 100px 10%;
  display: flex;
  align-items: flex-end;
  @media (max-width: $tablet) {
    padding: 50px 5%;
    flex-direction: column;
    align-items: center;
  }
  &__left {
    width: 55%;
    @media (max-width: $tablet) {
      width: 100%;
    }
    img {
      width: 100%;
    }
  }
  &__right {
    width: 35%;
    @media (max-width: $tablet) {
      width: 100%;
    }
    img {
      width: 100%;
      border-radius: 30px;
      margin-top: 50px;
    }
  }
}
.secondary-lockup {
  background-color: var(--color-mozzarella-1);
  padding: 50px 10% 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: -300px;
  @media (max-width: $tablet) {
    padding: 50px 5%;
    flex-direction: column;
    align-items: center;
  }
  &__left {
    width: 28%;
    margin-right: 2%;
    @media (max-width: $tablet) {
      width: 100%;
      margin-right: 0;
    }
  }
  &__right {
    width: 60%;
    @media (max-width: $tablet) {
      width: 100%;
    }
    img {
      width: 100%;
      border-radius: 30px;
    }
  }
}
.other-logos {
  display: flex;
  padding: 0 10% 100px;
  align-items: baseline;
  background-image: url('../assets/images/co-branding-razor.png');
  padding-top: 600px;
  justify-content: center;
  @media (max-width: $tablet) {
    padding: 50px 5%;
    flex-direction: column;
    align-items: center;
    margin-top: 200px;
  }
  &__left,
  &__right {
    width: 40%;
    margin: 0 5%;
    @media (max-width: $tablet) {
      width: 100%;
      margin: 100px 5% 0;
    }
    img {
      width: 100%;
    }
    h5,
    p {
      color: var(--color-white-1);
      img {
        width: 40px;
      }
    }
    h5 {
      display: flex;
      align-items: center;
      img {
        border: none;
        margin-right: 10px;
      }
    }
  }
  &__right {
    img {
      width: 80%;
      border-radius: 30px;
      border: 2px solid var(--color-white-1);
      @media (max-width: $tablet) {
        width: 100%;
      }
    }
  }
}
.footer {
  padding: 40px 10%;
  background-color: var(--color-mozzarella-1);
  &__body {
    text-align: center;
    color: var(--color-charcoal-1);
    &--link {
      color: var(--color-charcoal-1);
      font-weight: 600;
    }
  }
}

.outline {
  border: 2px solid var(--color-charcoal-1);
}
</style>